/*
 * @Author: van
 * @Date: 2021-09-30 09:46:23
 * @LastEditors: van
 * @LastEditTime: 2021-10-09 16:54:28
 */
export default{
  register:{
    firstName: "First Name",
    lastName: "Last Name",
    email: "邮箱",
    country: "国家",
    verificationCode: "验证码",
    selectPlaceholder:'请选择',
    inputPlaceholder:'请输入',
  },
  publicPart:{
    search:{
      searchTitle:'高级搜索',
      reset:'重置条件',
      search:'查询',
      startTime:'开始时间',
      endTime:'结束时间',
      to:'至',
      selectPlaceholder:'请选择',
      inputPlaceholder:'请输入',
      keyWord:'关键字',
    }
  },
  goodsList:{
    list:{
      batchPublication: '批量刊登',
      batchPublicationTip: '没有选择任何商品',
      filterBtnTxt: "筛选",
      filter:{
        month:"上新月份",
        price:"价格",
        weight:"产品重量",
        time:"发货时间",
        gender:"适用性别",
        season:"季节属性",
      }
    },
    tableName:{
        goodsName:'产品名称',
        goodsInfo:'产品信息',
        goodsImg:'产品图片',
        category:'分类',
        type:'类型',
        total_stock:'总库存',
        attribute:'个多属性',
        tag:'标签',
        keyWord:'关键字',
        create_time:'创建时间',
        update_time:'更新时间',
        operation:'操作',
    },
    add:{
          dialogTitle:'新增产品',
          goodsName:'产品名称',
          selectPlaceholder:'请选择',
          inputPlaceholder:'请输入',
          category:'产品分类',
          sku:'SKU',
          barcode:'产品条码',
          tags:'标签',
          keyword:'关键字',
          type:'是否多属性',
          goods_desc:'详细内容',
          images:'图片',
          add:'添加',
          price:'价格',
          currency:'货币',
          stock:'库存',
          value:'属性值',
          operation:'操作',
          save:'保存',
          close:'关闭',
    },
    edit:{
      dialogTitle:'产品编辑',
      goodsName:'产品名称',
      selectPlaceholder:'请选择',
      inputPlaceholder:'请输入',
      category:'产品分类',
      sku:'SKU',
      barcode:'产品条码',
      tags:'标签',
      keyword:'关键字',
      type:'是否多属性',
      goods_desc:'详细内容',
      images:'图片',
      add:'添加',
      price:'价格',
      currency:'货币',
      stock:'库存',
      value:'属性值',
      operation:'操作',
      save:'保存',
      close:'关闭',
    },
    detail:{
      dialogTitle:'产品详情',
      goodsName:'产品名称',
      selectPlaceholder:'请选择',
      inputPlaceholder:'请输入',
      category:'产品分类',
      sku:'SKU',
      barcode:'产品条码',
      tags:'标签',
      keyword:'关键字',
      type:'是否多属性',
      goods_desc:'详细内容',
      images:'图片',
      add:'添加',
      price:'价格',
      currency:'货币',
      stock:'库存',
      value:'属性值',
      operation:'操作',
      save:'保存',
      close:'关闭',
    },
    choosePlatform:{
      dialogTitle:'刊登平台',
      close:'关闭',
    },
    selectPlatform: {
      dialogTitle: '批量刊登',
      store: '店铺',
      template: '模板',
      vendor: '第三方',
      scope: 'Scope',
      status: '状态',
      statusRadios: {
        draft: '未激活',
        Draft: 'Draft',
        active: '激活',
        Active: 'Active',
        archived: '存档',
        Archived: 'Active'
      },
      selectPlaceholder: '请选择 ',
      inputPlaceholder: '请输入 ',
    },
    auth:{
      dialogTitle:'店铺授权',
      save:'授权',
      close:'关闭',
      inputPlaceholder:'请输入',
    },
    updateImg:{
      dialogTitle:'多属性产品图片',
      save:'保存',
      close:'关闭',
    },
    shopifyListing:{
      dialogTitle:'Shopify刊登',
      tabName1:'产品信息',
      tabName2:'多属性列表',
      selectPlaceholder:'请选择',
      inputPlaceholder:'请输入',
      shop:'店铺',
      goods_name:'产品名称',
      category:'产品分类',
      sku:'SKU',
      barcode:'产品条码',
      tags:'标签',
      keyword:'关键字',
      product_type:'产品类型',
      vendor:'供应商',
      published_scope:'渠道来源',
      listing_status:'状态',
      type:'是否多属性',
      goods_desc:'详细内容',
      images:'图片',
      add:'添加',
      price:'价格',
      currency:'货币',
      stock:'库存',
      value:'属性值',
      operation:'操作',
      save:'刊登',
      close:'关闭',
    },
    shoplazzaListing: {
      dialogTitle: 'Shoplazza刊登',
    },
    shoplineListing: {
      dialogTitle: 'Shopline刊登',
    },
  },
  shopifyList:{
    tableName:{
      itemID:'产品ID',
      goodsInfo:'产品信息',
      goodsImg:'产品图片',
      goods_name:'产品名称',
      shop_name:'店铺名称',
      status_cn:'状态',
      category_name:'产品类型',
      vendor:'供应商',
      tags: 'Tags',
      scope:'来源',
      create_time:'创建时间',
      published_time:'刊登时间',
      operation:'操作',
    },
    detail:{
      dialogTitle:'刊登产品详情',
      itemID:'产品ID',
      goods_name:'产品名称',
      shop_name:'店铺名称',
      category_name:'产品分类',
      vendor:'供应商',
      tags:'标签',
      keyword:'关键字',
      status:'状态',
      goods_desc:'详细内容',
      images:'图片',
      price:'价格',
      currency:'货币',
      stock:'库存',
      value:'属性值',
      close:'关闭',
      scope:'来源',
    }
  },
  storeList:{
    tableName:{
      status:'店铺状态',
      customer_ids:'客服专员',
      platform_id:'所属平台',
      id:'店铺ID',
      name:'店铺名称',
      open_date:'开店时间',
      create_at:'创建时间',
      authed:'是否授权',
      authed_success:'已授权',
      customized: 'Customized',
      authed_danger:'未授权',
      expire_time:'过期时间',
      operation:'操作',
    },
    auth:{
      dialogTitle:'店铺授权',
      save:'授权',
      close:'关闭',
      inputPlaceholder:'请输入',
    },
    add:{
      dialogTitle:'新增店铺',
      dialogTitle_edit:'店铺编辑',
      dialogTitle_detail:'店铺详情',
      selectPlaceholder:'请选择',
      inputPlaceholder:'请输入',
      name:'店铺名称',
      shop_abbr:'店铺简称',
      language:'语言',
      platform_id:'所属平台',
      open_date:'开店时间',
      shop_url:'店铺网址',
      shop_email:'店铺邮箱',
      save:'保存',
      close:'关闭',
      tip: '温馨提示：账号授权成功后，首次同歩数据需要20分钟以内，请耐心等待！',
    }
  },
  platformList:{
      tableName:{
        name:'平台名称',
        code:'平台编码',
        url:'链接',
        desc:'平台简介',
        sort:'排序',
        operation:'操作',
      },
      add:{
        dialogTitle:'新增平台',
        dialogTitle_edit:'平台编辑',
        name:'平台名称',
        selectPlaceholder:'请选择',
        inputPlaceholder:'请输入',
        code:'平台编码',
        url:'链接',
        desc:'平台简介',
        sort:'排序',
        save:'保存',
        close:'关闭',
      }
  },
  ordersList:{
    tableName:{
      order_sn:'订单号',
      status:'订单状态',
      platform_name:'所属平台',
      shop_name:'店铺名称',
      id:'订单ID',
      country:'国家',
      create_time:'创建时间',
      order_amount:'订单总额',
      operation:'操作',
      plt_order_sn:'平台单号',
      express_name:'发货方式',
      goods_num:'产品总数',
      buyer_name:'收货人',
      goods_items:'个',
      goods_item:'个',
      status_name:'状态',
    },
    add:{
      dialogTitle:'新增订单',
      dialogTitle_edit:'订单编辑',
      dialogTitle_detail:'订单详情',
      selectPlaceholder:'请选择',
      inputPlaceholder:'请输入',
      platform_id:'所属平台',
      save:'保存',
      close:'关闭',
    }
  },
  shoppingCart:{
    title: "购物车",
    table: {
      item: "项目",
      price: "价格",
      quantity: "数量",
      total: "总价",
      subtotal: "小计",
      remove: "删除",
      removeTip: "您确定要删除该项目吗"
    },
    checkout: {
      subtotal: "总计",
      discount: "优惠",
      total: "总价",
    }
  },
  downloadList: {
    tableName: {
      itemID: 'ItemID',
      goodsInfo: '产品信息',
      goodsImg: '产品图片',
      category_name: '分类',
      stock: '库存',
      operation: '操作',
      downloads: '下载',
      download_time: '下载时间',
    },
  },
  collectionList: {
    tableName: {
      itemID: 'ItemID',
      goodsInfo: '产品信息',
      goodsImg: '产品图片',
      category_name: '分类',
      stock: '库存',
      operation: '操作',
      downloads: '下载',
      download_time: '下载时间',
    },
  },
}